import { API } from 'aws-amplify'

export default async () => {
  return API.get('user', 'changelog')
}
